import {
  SET_PLC_POPUP_STATUS,
  SET_PLC_POPUP_STATUS_SUCCESS,
  SET_PLC_POPUP_STATUS_ERROR,
} from "./actionTypes";

export const setPlcPopupStatus = (status, token) => {
  return {
    type: SET_PLC_POPUP_STATUS,
    payload: { status, token },
  };
};

export const setPlcPopupStatusSuccess = (message, plc_popup_status) => {
  return {
    type: SET_PLC_POPUP_STATUS_SUCCESS,
    payload: { message, plc_popup_status },
  };
};

export const setPlcPopupStatusError = (message) => {
  return {
    type: SET_PLC_POPUP_STATUS_ERROR,
    payload: message,
  };
};
